// filecoin
const axios = require('axios')

const BASE_URI = 'https://api.nft.storage'
const API_KEY = process.env.REACT_APP_NFT_STORE_APIK

const requestOptions = {
  headers: {
    Authorization: `Bearer ${API_KEY}`
  }
}

export const CreateNFTStore = async (file) => {

  try {
    const URI = `${BASE_URI}/upload`
    let result = await axios.post(URI, file, requestOptions)
    return (
      (result.data.ok && {
          cidx: result.data.value.cid,
          urla: `https://ipfs.io/ipfs/${result.data.value.cid}`,
          urlb: `https://${result.data.value.cid}.ipfs.dweb.link`,
        }) ||
      ''
    )
  } catch (error) {
    return null
  }
 
}